export default __webpack_public_path__ + "23d6d6481855b7bbc5428e3844367404.png";